import script from "./base-header.vue?vue&type=script&setup=true&lang=ts"
export * from "./base-header.vue?vue&type=script&setup=true&lang=ts"

import "./base-header.vue?vue&type=style&index=0&id=2bb3cf6d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bb3cf6d"]])

export default __exports__